<div class="row mt-1">
  @for (item of [].constructor(16); track $index) {
    <div class="col-6 col-md-3">
      <ngx-skeleton-loader
        [theme]="{
          width: '100%',
          height: '180px',
          borderRadius: '20px',
        }"
      />
    </div>
  }
</div>
